var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',{attrs:{"icon-name":"preview"}},[_c('path',{staticClass:"blueStroke",attrs:{"d":"m 4,12 c 0,0 1.6,-6 8,-6 C 18.4,6 20,12 20,12"}}),_c('circle',{staticClass:"blueStroke",attrs:{"cx":"12","cy":"12","r":"3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }